import { Expose } from 'class-transformer';
import { TrailerLabel } from "@features/shipments/enums/trailer-label.enum";
import { Model } from '../../shared-features/models/model';

export class ShipmentRequestLabel extends Model {
  @Expose() id: number;
  @Expose() createdAt: number;
  @Expose() deletedAt: number;
  @Expose() isLatestLabel: boolean;
  @Expose() label: TrailerLabel;
  @Expose() targetDate$: any

  constructor() {
    super();
  }
}
